




























import { Vue, Component, Prop } from 'vue-property-decorator';
import Logo from '@/components/Logo.vue';
import NewTranslation from '@/components/i18n/NewTranslation.vue';
import CommuneProjection from '@/types/projections/CommuneProjection';

@Component({
  components: { NewTranslation, Logo },
})
export default class SplashHeader extends Vue {
  @Prop(Boolean)
  communeSelected!: boolean;

  @Prop(Boolean)
  accommodationDeactivatedError!: boolean;

  @Prop(String)
  appName!: string;

  @Prop(Object)
  currentLocation!: CommuneProjection;
}
